"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _statusIcon = _interopRequireDefault(require("../status-icon"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var cx = _classnames["default"].bind(_style["default"]);

var _ref2 = /*#__PURE__*/_jsx(_statusIcon["default"], {});

var CurrentStep = function CurrentStep(_ref) {
  var title = _ref.title,
      description = _ref.description;
  return /*#__PURE__*/_jsx("div", {
    className: cx('xsui-current-step')
  }, void 0, _ref2, /*#__PURE__*/_jsx("div", {
    className: cx('xsui-current-step__wrapper', !description && 'xsui-current-step__wrapper--centered')
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: cx('xsui-current-step__title', 'xsui-current-step__text')
  }, void 0, title), description && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-current-step__description', 'xsui-current-step__text')
  }, void 0, description)));
};

var _default = CurrentStep;
exports["default"] = _default;